import { TableHeaderCell } from 'ui/tableHeaderCell';
import { ColumnSpacedToggletip } from 'modules/experiments/components/ui/variantTable/Styles';
import { AlignTypes } from 'ui/tableHeader';

export type HeaderCellTypes = {
  headerName: string;
  sortable?: boolean;
  onClick?: () => null;
  tooltipContent?: string;
  align?: AlignTypes;
};

export const HeaderCell = ({
  headerName,
  sortable = false,
  onClick = () => null,
  tooltipContent,
  align = 'flex-start',
}: HeaderCellTypes) => {
  return (
    <TableHeaderCell
      key={headerName}
      columnData={{ name: headerName, align }}
      sortable={sortable}
      handleClick={onClick}
    >
      {headerName}
      {tooltipContent && (
        <ColumnSpacedToggletip
          iconProps={{ 'data-test': `${headerName}-tooltip` }}
          tooltipContent={tooltipContent}
        />
      )}
    </TableHeaderCell>
  );
};
